import { ICheckServiceRequest } from '../../../../../repositories/billing-tariffs/v3/check-service';
import {
  checkBusinessCenterCategory,
  checkJKCategory,
  getJKId,
  getBusinessCenterId,
  isObjectSplits,
} from '../../../../../utils';
import { getIsCommercial } from '../../../../../utils/category/getIsCommercial';
import { ICheckoutInfoState, ICoordinates, IOfferState, EMoneySource } from '../../../../reducers';
import { getIsCalltrackingPhoneChanged } from './getIsCalltrackingPhoneChanged';
import { ICheckPublishTermSchema } from '../../../../../repositories/monolith-python/entities/CheckPublishTermSchema';

export interface IGetCheckServiceParams {
  offer: IOfferState;
  locationPath: Array<number>;
  checkoutInfo: ICheckoutInfoState;
  terms: Array<ICheckPublishTermSchema>;
  isServiceChanged: boolean;
  photosCount: number;
  coordinates: ICoordinates;
  moneySource: EMoneySource | null;
  extraData: object;
}

export function getCheckServiceParams(params: IGetCheckServiceParams): ICheckServiceRequest {
  const {
    offer,
    locationPath,
    checkoutInfo,
    terms,
    isServiceChanged,
    photosCount,
    coordinates,
    moneySource,
    extraData,
  } = params;
  const { bargainTerms, totalArea, areaParts } = offer;

  const { id: objectId, category } = offer;

  const {
    autoProlongInfo: { isChecked: autoProlong },
  } = checkoutInfo;

  const isJKCategory = checkJKCategory(offer);
  const isBusinessCenterCategory = checkBusinessCenterCategory(offer);
  const newObjectId = getJKId(offer);
  const businessShoppingCenterId = getBusinessCenterId(offer);
  const isMultiListing = isObjectSplits(offer);
  const userHasChangedCalltrackingPhone = getIsCalltrackingPhoneChanged(offer);

  const result: ICheckServiceRequest = {
    ...(isJKCategory && { newObjectId }),
    ...(isBusinessCenterCategory && { businessShoppingCenterId }),
    ...(objectId && { objectId }),
    ...(category && { category }),
    locationPath: locationPath.reverse().join(','),
    autoProlong,
    terms,
    latitude: coordinates.lat,
    longitude: coordinates.lng,
    isMultiListing,
    userHasChangedServices: isServiceChanged,
    userHasChangedCalltrackingPhone,
    photosCount,
    sourceType: 'website',
    uiType: 'desktop',
    moneySource,
    extraData,
  };

  const isCommercial = !!category && getIsCommercial(category);

  if (isCommercial) {
    Object.assign<ICheckServiceRequest, Partial<ICheckServiceRequest>>(result, {
      price: bargainTerms.price,
      currency: bargainTerms.currency,
      priceType: bargainTerms.priceType,
      paymentPeriod: bargainTerms.paymentPeriod,
      totalArea,
      multiListingSlotsCount: areaParts?.length ?? null,
    });
  }

  return result;
}
